export default __webpack_public_path__ + "static/media/babyShoes.23d8226c.svg";